// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__yo4EP","link":"styles_link__QMU_T","apple":"styles_apple__9qzKv","placeholder":"styles_placeholder__8pGSu","google":"styles_google__nTXD6"};